import { render, staticRenderFns } from "./LEDPCB65Less.vue?vue&type=template&id=00f1cb60&scoped=true&"
import script from "./LEDPCB65Less.vue?vue&type=script&lang=js&"
export * from "./LEDPCB65Less.vue?vue&type=script&lang=js&"
import style0 from "./LEDPCB65Less.vue?vue&type=style&index=0&id=00f1cb60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f1cb60",
  null
  
)

export default component.exports